import type { RelationshipT } from '../types/relationship';
import type { RelationshipBasePayloadT } from './types';
export const getRelationshipBasePayload = (relationship: RelationshipT): RelationshipBasePayloadT => ({
  relationshipId: relationship.id,
  relationshipPredicateName: relationship.relationshipLabel.relationshipLabelName,
  sourceObjectId: relationship.sourceAnnotationId,
  sourceClass: relationship.relationshipLabel.classConstraints.source[0] ?? '',
  targetObjectId: relationship.targetAnnotationId,
  targetClass: relationship.relationshipLabel.classConstraints.target[0] ?? '',
  temporalScope: relationship.relationshipLabel.temporalConstraints?.temporalScope,
  frameRanges: relationship.frameRanges,
  cardinality: relationship.relationshipLabel.cardinalityConstraints?.cardinality
});